/**
 * Notification service — in-app alerts (new enquiries, etc.).
 */
import api from './api';

class NotificationService {
  async getUnreadCount() {
    const res = await api.get('/api/notifications/unread-count');
    return res.data?.unread ?? 0;
  }

  async list(limit = 20) {
    const res = await api.get('/api/notifications', { params: { limit } });
    return res.data || { notifications: [], unread: 0 };
  }

  async markRead(id) {
    const res = await api.post(`/api/notifications/${id}/read`);
    return res.data;
  }

  async markAllRead() {
    const res = await api.post('/api/notifications/read-all');
    return res.data;
  }
}

const notificationService = new NotificationService();
export default notificationService;
